var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"author-hint"},[_c('user-avatar',{attrs:{"username":_vm.user.username,"size":50}}),_c('div',{staticClass:"author-hint__name"},[_vm._v(_vm._s(_vm.user.name)+" "+_vm._s(_vm.user.surname))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }